import Basic from '@/components/page/Basic.js'
import { Rainbow, Rainbow2, AxiosWithJar,Config } from '@/utility.js'

export default{
	extends: Basic,
	props:["branchid"],
	data:()=>({
		ytd: {
			sales:{rekap:[], spd:[], ytdchart:{}, mtdchart:{}, spdchart:{}}, 
			margin:{rekap:[], ytdchart:{}, mtdchart:{}}, 
			losses:{rekap:[], ytdchart:{}, mtdchart:{}}, 
			basket:{invoice:[], size:[]}, 
		},
		store: {area:[], region:[],  province:[], list:[]},
		weekly:{
			spd:[], sales:[], margin:[], inv:[], basket:[], waste:[],
			compwaste:[],
			top: [], flop: [],
			slscase:[], slsline:[], slsdcase: [], slsdline: [], sldcase:[], sldline:[],
		},			
		stock: {
			area:[], div:[], dept:[], divchart:[], deptchart:[],
			agingarea:[], agingdiv:[], notsoldarea:[], notsolddiv:[],
			oos: {item:[], store:[], compitem: [], compstore: []},
			poos: {item:[], store:[], compitem: [], compstore: []},
			detentionrate:[], 
		},
		loading: { table:true },
	}),
	methods:{
	
		async loadYTD() {
			let url = Config().apiURL + "/cafe/ytd?" + (this.branchid ? "&branchid=" + this.branchid : "")
			await AxiosWithJar().get(url).then(result => {
				//console.log('ytd cafe: '+ JSON.stringify(result.data))
				if (result.data.sales.length) {
					this.ytd.sales = {
						rekap: this.processYTD(result.data.sales, "Info", "SalesExTax", false, "Grup", 1, 2),
						spd: this.processYTD(result.data.sales, "Info", "SalesExTax", "StoreCount", "Grup", 1, 2, false, false, "NumDay"),
						ytdchart: this.processBarChart(result.data.sales, "Info", "", "SalesExTax", false, "SalesArea", "AREA ", 1000000000, 2, Rainbow, "Grup", [1], true),
						mtdchart: this.processBarChart(result.data.sales, "Info", "", "SalesExTax", false, "SalesArea", "AREA ", 1000000000, 2, Rainbow2, "Grup", [2], true),
						spdchart: this.processBarChart(result.data.sales, "Info", "", "SalesExTax", "StoreCount", "SalesArea", "AREA ", 1000000, 2, Rainbow, "Grup", [4], true, false, "NumDay"),
					};
					this.ytd.margin = {
						rekap: this.processYTD(result.data.margin, "Info", "Margin", "SalesExTax", "Grup", 0.01, 2),
						ytdchart: this.processBarChart(result.data.margin, "Info", "", "Margin", "SalesExTax", "SalesArea", "AREA ", 0.01, 2, Rainbow, "Grup", [1], true),
						mtdchart: this.processBarChart(result.data.margin, "Info", "", "Margin", "SalesExTax", "SalesArea", "AREA ", 0.01, 2, Rainbow2, "Grup", [2], true),
					};
					this.ytd.losses = {
						rekap: this.processYTD(result.data.losses, "Info", "Losses", false, "Grup", 1, 2),
						ytdchart: this.processBarChart(result.data.losses, "Info", "", "Losses", false, "SalesArea", "AREA ", 1000000, 2, Rainbow, "Grup", [1], true),
						mtdchart: this.processBarChart(result.data.losses, "Info", "", "Losses", false, "SalesArea", "AREA ", 1000000, 2, Rainbow2, "Grup", [2], true),
					};
					this.ytd.basket = {
						invoice: this.processYTD(result.data.basket, "Info", "NoOfInvoice", false, "Grup", 1, 2),
						size: this.processYTD(result.data.basket, "Info", "SalesExTax", "NoOfInvoice", "Grup", 1, 2, false),
					};
				
				}

				//console.log('ytd sales : ' + JSON.stringify(result.data.sales))
				//console.log('ytd sales cafe ALL: ' + JSON.stringify(this.ytd.sales.rekap))
				//console.log('ytd sales cafe: ' + JSON.stringify(this.ytd.sales.rekap[3]))

				//console.log('ytd losses cafe ALL: ' + JSON.stringify(this.ytd.losses.rekap))
			})
		},
		
		async loadStore() {
			let url = Config().apiURL + "/cafe/cafe"
			await AxiosWithJar().get(url).then(result => {
				if (result.data.area.length) {
					this.store.area = result.data.area;
					this.store.region = result.data.region;
					this.store.province = result.data.province;
				}
			})
		},

		async loadStoreList() {
			let url = Config().apiURL + "/cafe/cafelist";
			await AxiosWithJar().get(url).then(result=>{
				if(result.data.data.length){
					this.store.list = result.data.data;
				}
			})
		},
		
		weeklyChart(data, col, factor) {
			return this.processBarChart(data, 'WeekNo', 'WK ', col, false, (this.branchid ? '' : 'SalesArea'), (this.branchid ? '' : 'AREA '), factor, 2, Rainbow)
		},
		
		async loadWeekly() {
			let url = Config().apiURL + "/cafe/weekly?count=8" + (this.branchid ? "&branchid=" + this.branchid : "")
			await AxiosWithJar().get(url).then(result => {
				if (result.data.weekly.length) {
					this.weekly.spd = this.weeklyChart(result.data.weekly, 'SalesPerDay', 1000000);
					this.weekly.sales = this.weeklyChart(result.data.weekly, 'SalesExTax', 1000000);
					this.weekly.margin = this.weeklyChart(result.data.weekly, 'MarginPct', 1);
					this.weekly.inv = this.weeklyChart(result.data.weekly, 'NoOfInvoice', 1);
					this.weekly.basket = this.weeklyChart(result.data.weekly, 'AverageBasket', 1000);
					this.weekly.waste = this.weeklyChart(result.data.weekly, 'Waste', 1000000);
					this.weekly.compspd = this.createComp(result.data.totalweekly, "WeekNo", "SalesPerDay", result.data.totalweekly.length - 1, result.data.totalweekly.length - 2);
					this.weekly.compwaste = this.createComp(result.data.totalweekly, "WeekNo", "Waste", result.data.totalweekly.length - 1, result.data.totalweekly.length - 2);
					this.weekly.slscase = this.processBarChart(result.data.sls, 'WeekNo', 'WK ', 'CaseFillPct', false, 'BranchType', '', 1, 2, Rainbow)
					this.weekly.slsline = this.processBarChart(result.data.sls, 'WeekNo', 'WK ', 'LineFillPct', false, 'BranchType', '', 1, 2, Rainbow)
					this.weekly.slsdcase = this.processBarChart(result.data.slsd, 'WeekNo', 'WK ', 'CaseFillPct', false, 'BranchName', '', 1, 2, Rainbow)
					this.weekly.slsdline = this.processBarChart(result.data.slsd, 'WeekNo', 'WK ', 'LineFillPct', false, 'BranchName', '', 1, 2, Rainbow)
					this.weekly.sldcase = this.processBarChart(result.data.sld, 'WeekNo', 'WK ', 'CaseFillPct', false, 'DCName', '', 1, 2, Rainbow)
					this.weekly.sldline = this.processBarChart(result.data.sld, 'WeekNo', 'WK ', 'LineFillPct', false, 'DCName', '', 1, 2, Rainbow)
					this.weekly.compslsdline = this.createComp(result.data.slsd, 'WeekNo', 'LineFillPct', result.data.slsd.length - 1, result.data.slsd.length - 2);
					this.weekly.compsldline = this.createComp(result.data.sld, 'WeekNo', 'LineFillPct', result.data.sld.length - 1, result.data.sld.length - 2);
				}
			})
		},
		
		async loadTopFlop() {
			let url = Config().apiURL + "/bright/topflop?count=8"
			await AxiosWithJar().get(url).then(result => {
				if (result.data.top.length) {
					this.weekly.top = this.topFlopDataToTable(result.data.top)
					this.weekly.flop = this.topFlopDataToTable(result.data.flop)

					/*
					this.weekly.top.sortOption.sortChange=(params)=>{
						alert(JSON.stringify(params))
						this.sortChange(params)
					}
					*/


				}
			})
		},

		sortChange(params) {
			this.weekly.top.tableData.sort((a, b) => {
				if (params.storeId) {
					if (params.storeId === "asc") {
						return a.storeId - b.storeId;
					} else if (params.storeId === "desc") {
						return b.storeId - a.storeId;
					} else {
						return 0;
					}
				} else if (params.storeName) {
					if (params.storeName === "asc") {
						return a.storeName - b.storeName;
					} else if (params.storeName === "desc") {
						return b.storeName - a.storeName;
					} else {
						return 0;
					}
				} 

			})
			
		}
		,


		async loadOOS() {
			let url = Config().apiURL + "/bright/oos?count=8"
			await AxiosWithJar().get(url).then(result => {
				//console.log(result.data);
				if (result.data.oos.length) {
					this.stock.oos = {
						item: this.processBarChart(result.data.oos, "StockDate", "", "PctItem", false, "SalesArea", "AREA ", 1, 2, Rainbow),
						store: this.processBarChart(result.data.oos, "StockDate", "", "CountBranch", false, "SalesArea", "AREA ", 1, 2, Rainbow),
						compitem: this.createComp(result.data.totaloos, "StockDate", "PctItem"),
						compstore: this.createComp(result.data.totaloos, "StockDate", "CountBranch"),
					};
					this.stock.poos = {
						item: this.processBarChart(result.data.poos, "StockDate", "", "PctItem", false, "SalesArea", "AREA ", 1, 2, Rainbow),
						store: this.processBarChart(result.data.poos, "StockDate", "", "CountBranch", false, "SalesArea", "AREA ", 1, 2, Rainbow),
						compitem: this.createComp(result.data.totalpoos, "StockDate", "PctItem"),
						compstore: this.createComp(result.data.totalpoos, "StockDate", "CountBranch"),
					};
				}
			})
		},
	
		async loadStock() {
			let url = Config().apiURL + "/bright/stock"
			await AxiosWithJar().get(url).then(result => {
				if (result.data.area.length) {
					this.stock.area = result.data.area;
					this.stock.div = result.data.div;
					this.stock.dept = result.data.dept;
					this.stock.divchart = this.processBarChart(result.data.areadiv, "SalesArea", "AREA ", 'StockValue', false, 'DivisiName', '', 1000000, 2, Rainbow);
					this.stock.deptchart = this.processBarChart(result.data.areadept, "SalesArea", "AREA ", 'StockValue', false, 'DepartmentName', '', 1000000, 2, Rainbow);
					this.stock.agingarea = this.processBarChart(result.data.agingarea, 'Kriteria', '', 'StockValue', false, "SalesArea", "AREA ", 1000000, 2, Rainbow2);
					this.stock.agingdiv = this.processBarChart(result.data.agingdiv, 'Kriteria', '', 'StockValue', false, "DivisiName", "", 1000000, 2, Rainbow2);
					this.stock.notsoldarea = this.processBarChart(result.data.notsoldarea, 'Kriteria', '', 'StockValue', false, "SalesArea", "AREA ", 1000000, 2, Rainbow2);
					this.stock.notsolddiv = this.processBarChart(result.data.notsolddiv, 'Kriteria', '', 'StockValue', false, "DivisiName", "", 1000000, 2, Rainbow2);
				}
			})
		},
		
		async loadDetentionRate() {
			let url = Config().apiURL + "/bright/detentionrate?count=8"
			await AxiosWithJar().get(url).then(result => {
				//console.log(result.data);
				if (result.data.detentionrate.length) {
					this.stock.detentionrate = this.processBarChart(result.data.detentionrate, "StockDate", "", "DetentionRate", false, "SalesArea", "AREA ", 0.01, 0, Rainbow);
				}
			})
		},
	
	},
}